import MasterTable from "../../views/dashboard/widget/MasterTabel";
import { useGlobalState } from "../../services/hostelConst.js";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getDivisionSectionList,
  deleteDivisionSection,
  updateDivisionSectionStatus,
} from "../../services/Academic-Services";
import AddClassesForm from "../../components/FormComponents/AddClasses.js";
import AddDivisionSectionForm from "../FormComponents/AddDivisionSection";
const DivisionSectionTable = () => {
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
  } = useGlobalState();
  useEffect(() => {
    resetAdvanceFilterData();
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });

    return () => {};
  }, []);

  return (
    <>
      <MasterTable
        getTableData={getDivisionSectionList}
        deleteRow={deleteDivisionSection}
        updateStatus={updateDivisionSectionStatus}
        tab1={"Academic"}
        AddForm={AddDivisionSectionForm}
        tab2={"Division Sections"}
        actions={{
          status: true,
          edit: true,
          delete: true,
        }}
      />
    </>
  );
};

export default DivisionSectionTable;
